import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"
import * as styles from "./SupportImageTextBlock.module.scss"

const WorkingdayImageTextBlock = ({ data }) => {
  let imageLeftOrRight

  imageLeftOrRight =
    data.imageLeftOrRight[0] === "Right"
      ? "lg:order-1 lg:ml-20 order-1"
      : "lg:order-first lg:mr-20 order-1"

 if (data.image.gatsbyImageData) {
    return (
      <div
        className={`lg:flex lg:flex-row lg:max-w-[1218px] mx-auto flex flex-col font-sans items-center justify-between lg:py-[60px] py-[45px] lg:px-0 px-[16px] ${styles.workingdaywrapper}`}
      >
        <GatsbyImage
          image={data.image?.gatsbyImageData}
          alt={data.image.description ? data.image.description : "image"}
          className={imageLeftOrRight + " mx-5 md:mx-0 lg:w-[513px] "}
          loading={"eager"}
        />
        <div
          className={
            "lg:max-w-[587px] lg:mr-0 md:hyphens-none hyphens-auto break-words "
          }
        >
          <RenderRichContent content={data.text} />
        </div>
      </div>
    )
  }  else {
    return <></>
  }
}
export default WorkingdayImageTextBlock
